import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import MobileMenu from '../../../acets/icon/mobilemenu.svg'
import MobileProfile from '../../../acets/icon/mobileprofile.svg'
import MobileHome from '../../../acets/icon/mobilehome.svg'

export default function menumobile() {


return(
    <div className='w100 h7 row around b32 posifixedfim  desktop-none'>
         <Link to="/pagemobilemenu" className='column center w30'>
          <img src={MobileMenu} alt='MobileMenu' className='w25'/>
            <label className='fs08em c3'>Menu</label>
          </Link>
          <Link to="/painel" className='column center w30'>
            <img src={MobileHome} alt='MobileMenu' className='w25'/>
            <label className='fs08em c3'>Home</label>
          </Link>
          <Link to="/perfil" className='column center w30'>
            <img src={MobileProfile} alt='MobileMenu' className='w25'/>
            <label className='fs08em c3'>Profile</label>
          </Link>
         </div>
)

}